import React from 'react';
import {Link} from 'react-router-dom';

const menuItems = [
  {title: 'Vocabulary', icon: 'translate', page: 'vocabulary', tone: 'indigo', desc: 'Build a stronger working vocabulary through short reviews.', action: 'Open vocabulary'},
  {title: 'Writing', icon: 'edit_note', page: 'writing', tone: 'violet', desc: 'Write naturally and get focused feedback on your choices.', action: 'Start writing'},
  {title: 'Speaking', icon: 'record_voice_over', page: 'speaking', tone: 'teal', desc: 'Speak at your pace and sharpen everyday pronunciation.', action: 'Start speaking'},
  {title: 'Grammar', icon: 'menu_book', page: 'grammar', tone: 'amber', desc: 'Turn rules into patterns through practical exercises.', action: 'Study grammar'}
];

const Home = () => {
  return (
      <main className="page-container home-page">
        <section className="home-hero" aria-labelledby="home-title">
          <div>
            <span className="eyebrow">Today’s practice</span>
            <h1 id="home-title">English practice</h1>
            <p>Choose a skill and begin.</p>
          </div>
          <div className="home-hero__mark" aria-hidden="true">
            <span>hello</span>
            <i className="material-icons">north_east</i>
          </div>
        </section>

        <section aria-labelledby="practice-title">
          <div className="section-heading home-section-heading">
            <div>
              <h2 id="practice-title">Choose a skill</h2>
              <p>Each session is matched to your current level.</p>
            </div>
            <span className="home-section-heading__hint"><i className="material-icons" aria-hidden="true">schedule</i> About 10 min</span>
          </div>
          <div className="practice-grid">
            {menuItems.map((item) => (
                <Link className={`practice-card practice-card--${item.tone}`} key={item.page} to={`/${item.page}`} aria-label={`${item.action}: ${item.title}`}>
                  <div className="practice-card__icon"><i className="material-icons" aria-hidden="true">{item.icon}</i></div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                  <span className="practice-card__action">
                    {item.action}<i className="material-icons" aria-hidden="true">arrow_forward</i>
                  </span>
                </Link>
            ))}
          </div>
        </section>
      </main>
  );
};

export default Home;
